import React, { FC, useCallback, useMemo } from 'react';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { List, Input, Radio, Checkbox } from 'antd';
import { getFollowUpActionIndicator } from '../../utils/SiteSurveyUtils';
import WalkthroughTaskListAnswerDisplay from '../walkthroughs_detail_details_page/WalkthroughTaskListAnswerDisplay';
interface ITaskListRO {
	tasks: any;
}

const DefaultTitle = '---';

const TaskListRO: FC<ITaskListRO> = ({ tasks }): React.ReactElement => {
	const groups = useMemo(() => {
		const groupings = {};
		const sortedTasks = tasks.sort((a, b) => {
			const id1 = a.orderingId || 0;
			const id2 = b.orderingId || 0;
			return id1 - id2;
		});
		sortedTasks.map((task) => {
			const title = task.groupTitle || DefaultTitle;
			groupings[title] = groupings[title] ? [...groupings[title], task] : [task];
		});
		return groupings;
	}, [tasks]);

	const getFormField = useCallback((task) => {
		switch (task.questionType) {
			case 'multipleChoice':
				return nullSafeGetOrElse('multipleChoicesWithLabel.length', task, 0) !== 0 ? (
					<Radio.Group className="w-full">
						{task.multipleChoicesWithLabel.map((choice, idx) => {
							const followUpIndicator = getFollowUpActionIndicator(choice.followUpActions);
							return (
								// Wrap each option in a block div so they stack vertically —
								// antd's .ant-radio-wrapper is inline-flex and overrides Tailwind
								// display utilities placed on the group itself.
								<div key={`rg-${idx}`} className="mb-3 last:mb-0">
									<Radio value={choice.value} disabled={true}>
										<span className="mr-2 text-character-secondary">
											{`${choice.value}${choice.description ? ` (${choice.description})` : ''}`}
										</span>
										{followUpIndicator && (
											<span className="footnoteregular text-character-secondary">
												{followUpIndicator}
											</span>
										)}
									</Radio>
								</div>
							);
						})}
					</Radio.Group>
				) : (
					''
				);
			case 'taskList':
				return (
					<WalkthroughTaskListAnswerDisplay
						taskAnswer={{
							taskListAnswer: [{ title: '__' }],
						}}
						hideDisabledHelper
					/>
				);
			case 'checklist': {
				const items = nullSafeGetOrElse('checklistTasks', task, []);
				return items.length > 0 ? (
					<div className="flex flex-col gap-2">
						{items.map((item, idx) => (
							<div key={`cl-${idx}`} className="flex flex-row items-baseline">
								<Checkbox disabled />
								<div className="pl-2 leading-6 text-character-secondary">{item.title}</div>
							</div>
						))}
					</div>
				) : (
					''
				);
			}
			default:
				return <Input.TextArea disabled={true} placeholder="" />;
		}
	}, []);

	return (
		<List itemLayout="vertical">
			{Object.keys(groups as any).map((key, idx) => (
				<List.Item key={idx}>
					{key !== DefaultTitle && <List.Item.Meta title={key} />}
					<List
						itemLayout="vertical"
						style={{ padding: `0 ${key !== DefaultTitle ? '24px' : ''}` }}
						dataSource={groups[key]}
						renderItem={(item) => {
							const task = item as any;
							const taskFollowUpIndicator = getFollowUpActionIndicator(task.followUpActions);
							return (
								<div>
									<List.Item>
										<List.Item.Meta
											title={
												<div className="flex flex-row flex-wrap items-baseline gap-2">
													<span>{task.title}</span>
													{taskFollowUpIndicator && (
														<span className="footnoteregular text-character-secondary">
															{taskFollowUpIndicator}
														</span>
													)}
												</div>
											}
											description={
												task.description ? (
													<span className="bodyregular text-character-secondary">
														{task.description}
													</span>
												) : null
											}
										/>
										<div>{getFormField(task)}</div>
									</List.Item>
								</div>
							);
						}}
					/>
				</List.Item>
			))}
		</List>
	);
};

export default TaskListRO;
